module.exports = __webpack_public_path__ + "static/media/bus.da545c85.png";